import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Link } from 'react-router-dom';
// import Listing from '../../Images/listing.png';
import Uploaded from '../../Images/uploaded.png';
// import Uploadlisting from '../../Images/uploadlisting.png';
// import Docsample from '../../Images/docsample.png';
import { Row, Col, Form, Upload, Button, Icon } from 'antd';
import { withRouter } from 'react-router';
import { withAppContext } from '../../store/contextStore';
import Amplify, { Storage } from 'aws-amplify';
import awsConfigure from '../../Config/AwsConfig';
import { updateCustomerOrCarrierDetails, getCustomerOrCarrierDetails } from "../../api/OraganizationApis";
import Docsample from "../../Images/pdf.jpg";

Amplify.configure(awsConfigure);

class EditDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            uploading: false,
            documentsUploaded: false,
            coiUploaded: false,
            w9Uploaded: false,
            tcUploaded: false,
            uploadName: "",
            documents: {}
        }
    }
    componentDidMount() {
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let userDetails = JSON.parse(localStorage.getItem("userDetails"));

        // this.props.form.setFieldsValue({
        //     "coi": orgDetails["carrierFiles"]["documents"]["coi"],
        //     "w9": orgDetails["carrierFiles"]["documents"]["w9"],
        //     "tandc": orgDetails["carrierFiles"]["documents"]["tandc"],
            
        //   });
        // let coi = Docsample, w9 = Docsample, tandc = Docsample;
        // if (orgDetails["carrierFiles"] && orgDetails["carrierFiles"]["documents"]) {
        //   coi = Storage.get(orgDetails["carrierFiles"]["documents"]["coi"]);
        //   coi = Storage.get(orgDetails["carrierFiles"]["documents"]["w9"]);
        //   coi = Storage.get(orgDetails["carrierFiles"]["documents"]["tandc"]);
        // }
        this.setState({
            orgDetails: orgDetails,
            userDetails: userDetails,
            uploadImgLoading: false,
            dataLoadingStatus: false,
            carrierInfo: orgDetails,
            documents: orgDetails["carrierFiles"]["documents"]
            // coi,
            // w9,
            // tandc
          })
          console.log(orgDetails)
    }
    handleUpload = () => {
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let docKeys = this.state.documents, fileName;
        if(this.state.fileList.length === 0) {
            alert("Please upload at least one new document for update!");
            return;
        }
        this.setState({
            uploading: true
        })
        this.state.fileList.map(async (file, index) => {
            if(file["fileBelongsTo"]) {
                fileName = orgDetails["id"] + "_" + file["name"];
                await Storage.put(fileName, file, {
                    contentType: file.type,
                }).then(result => {
                    docKeys[file["fileBelongsTo"]] = [];
                    docKeys[file["fileBelongsTo"]].push(result.key);
                    if (this.state.fileList.length === index + 1) {
                        let data = {
                            "entityData": {
                                "carrierFiles": {
                                    "documents": docKeys,
                                    "trucks": orgDetails["carrierFiles"]["trucks"]
                                },
                                "isDocumentUpload": true
                            }
                        }
                        updateCustomerOrCarrierDetails(orgDetails["id"], data)
                            .then(result => {
                                if (result.success) {
                                    this.setState({
                                        documentsUploaded: true
                                    })
                                    getCustomerOrCarrierDetails(orgDetails["id"])
                                        .then(result => {
                                            if (result.success) {
                                                localStorage.setItem("orgDetails", JSON.stringify(result.data));
                                                this.props.history.push('/carrier_app/carriersettings');
                                            }
                                        });
                                } else {
                                    console.log(result.errors);
                                }
                            });
                    }
                })
                .catch(err => console.log(err));
            }
        });
    }
    fileDownload = async (fileName) => {
        this.setState({
            pageLoading:true
        })
        Storage.get(fileName, { download: true })
            .then(res => this.downloadBlob(res.Body, fileName))
      }
    
      downloadBlob(blob, filename) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        const clickHandler = () => {
          setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener('click', clickHandler);
          }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
        this.setState({
            pageLoading:false
        })
        return a;
      }

    render() {
        const firstupload = {
            // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange({ file, fileList }) {
                if (file.status !== 'uploading') {
                }
            },
            beforeUpload: file => {
                file["fileBelongsTo"] = "coi";
                this.setState(state => ({
                    fileList: [...state.fileList, file],
                }));
                return false;
            }
        };
        const secondupload = {
            // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange({ file, fileList }) {
                if (file.status !== 'uploading') {
                }
            },
            beforeUpload: file => {
                file["fileBelongsTo"] = "w9";
                this.setState(state => ({
                    fileList: [...state.fileList, file],
                }));
                return false;
            }
        };
        // const thirdupload = {
        //     // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        //     onChange({ file, fileList }) {
        //         if (file.status !== 'uploading') {
        //         }
        //     },
        //     beforeUpload: file => {
        //         file["fileBelongsTo"] = "tandc";
        //         this.setState(state => ({
        //             fileList: [...state.fileList, file],
        //         }));
        //         return false;
        //     }
        // };
        const fourthupload = {
            // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange({ file, fileList }) {
                if (file.status !== 'uploading') {
                }
            },
            beforeUpload: file => {
                file["fileBelongsTo"] = "nda";
                this.setState(state => ({
                    fileList: [...state.fileList, file],
                }));
                return false;
            }
        };
        const { uploading } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <div className="Docdiv">

                    <Row type="flex" justify="start" style={{ marginTop: '4%' }}>
                        <Col span={4} />


                        <Col span={16} style={{ backgroundColor: 'white', height: '490px', borderRadius: '10px', padding: '40px' }}>
                            <div>
                                <h3>Documents</h3>
                                <p style={{ fontSize: '17px', color: '#7B8190' }}>Please, upload documents.</p>
                                {/* <p style={{ fontSize: '20px', color: '#7B8190' }}>I'm uploading:</p> */}
                                <div>
                                    <Form onSubmit={this.handleSubmit}>
                                        <Form.Item>
                                            {getFieldDecorator('coi')}
                                            <Row>
                                                <Col span={10}>
                                                    <><img src={Uploaded} style={{ marginRight: 10 }} alt="img" />COI</>
                                                </Col>
                                                
                                                <Col span={14}>
                                                    <div style={{marginLeft: '50%'}}>
                                                    <Upload name='coi' {...firstupload} >
                                                        <Button onClick={() => { this.setState({ uploadName: "coi" }) }} >
                                                            <Icon type="upload" />Upload
                                                        </Button>
                                                    </Upload>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                        <Form.Item >
                                            {getFieldDecorator('w9')}
                                            <Row>
                                                <Col span={10}>
                                                    <><img src={Uploaded} style={{ marginRight: 10 }} alt="img" />W-9</>
                                                </Col>
                                                <Col span={14}>
                                                    <div style={{marginLeft: '50%'}}>
                                                    <Upload name='w9' {...secondupload} >
                                                        <Button onClick={() => { this.setState({ uploadName: "w9" }) }}>
                                                            <Icon type="upload" />Upload
                                                        </Button>
                                                    </Upload>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                        {/* <Form.Item >
                                            {getFieldDecorator('tandc')}
                                            <Row>
                                                <Col span={10}>
                                                    <><img src={Uploaded} style={{ marginRight: 10 }} alt="img" />Terms and service agreement</>
                                                </Col>
                                                <Col span={7}>
                                                    <span style ={{cursor:"pointer"}} onClick={()=>{this.fileDownload("DeFeoMaterialsCreditApp14Days.pdf")}}>
                                                        <h4 style={{ color: '#7B8190', fontSize: '13px', textAlign: 'center' }}>Download Terms and Conditions &nbsp; <img src={Docsample} alt="Doc" title="Download" style={{width:"25px", height:"30px"}} /></h4>
                                                    </span>
                                                </Col>
                                                <Col span={7}>
                                                    <Upload name='tandc' {...thirdupload}>
                                                        <Button onClick={() => { this.setState({ uploadName: "tandc" }) }}>
                                                            <Icon type="upload" />Upload
                                                        </Button>
                                                    </Upload>
                                                </Col>
                                            </Row>
                                        </Form.Item> */}
                                        <Form.Item >
                                            {getFieldDecorator('nda')}
                                            <Row>
                                                <Col span={10}>
                                                    <><img src={Uploaded} style={{ marginRight: 10 }} alt="img" />NDA</>
                                                </Col>
                                                <Col span={7}>
                                                    <span style ={{cursor:"pointer"}} onClick={()=>{this.fileDownload("PrefilledNDA.pdf")}}>
                                                        <h4 style={{ color: '#7B8190', fontSize: '13px', textAlign: 'center' }}>Download NDA &nbsp; <img src={Docsample} alt="Doc" title="Download" style={{width:"25px", height:"30px"}} /></h4>
                                                    </span>
                                                </Col>
                                                <Col span={7}>
                                                    <Upload name='nda' {...fourthupload}>
                                                        <Button onClick={() => { this.setState({ uploadName: "nda" }) }}>
                                                            <Icon type="upload" />Upload
                                                        </Button>
                                                    </Upload>
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                        <Form.Item style={{ textAlign: 'center', marginTop: "6%" }}>
                                            <Button type="primary" style={{ backgroundColor: '#25559517', color: '#255595', marginRight: '30px', padding: '0 20px 0 20px', border: 'none' }}>
                                                <Link to="/carrier_app/carriersettings">
                                                    Cancel
                                                </Link>
                                            </Button>
                                            <Button
                                            type="primary"
                                                onClick={this.handleUpload}
                                                // disabled={fileList.length !== 3} 
                                                loading={uploading}
                                                >
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Form.create({ name: 'EditDocuments' })(withAppContext(withRouter(EditDocuments)));


